export const GET_TYPE_STORAGE = 'GET_TYPE_STORAGE'
export const GET_TYPE_STORAGE_EXITO = 'GET_TYPE_STORAGE_EXITO'
export const GET_TYPE_STORAGE_ERRROR = 'GET_TYPE_STORAGE_ERROR'
